import makeStyles from '@material-ui/core/styles/makeStyles';

export default makeStyles(theme => ({
  downloadWarningDialog: {
    maxHeight: 500,
    maxWidth: 926,
  },
  downloadConfirmModal: {
    maxHeight: 350,
    maxWidth: 840,
  },
}));
